/**
 * @prettier
 * @flow
 */
export function transformStringInput(value?: ?string): string {
    return value ?? '';
}
